import { Component } from 'shimmer'

import { webGL } from '@/webGL/WebGL'
import { MeshNormalMaterial } from 'three'

class Neon extends Component {
  constructor () {
    super()

    this.addToLayer = this.addToLayer.bind(this)
  }

  addToLayer ({name = null, object = null}) {
    if (name) {
      object = webGL.scene.getObjectByName(name)
    }

    if (object) {
      if (object.isMesh) {
        this.treatObject(object)
      }
      else {
        object.traverse( (child) => {
          if (child.isMesh) {
            this.treatObject(child)
          }
        })
      }
    }
  }

  treatObject (mesh) {
    mesh.material.dispose()
    mesh.material = new MeshNormalMaterial()
    mesh.layers.enable(1)
  }
}

export const neon = new Neon()